import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { replaceByElement } from "../../../../../utils/Logs";
import { Log } from "../../../../../types/Logs";

export default function EmployeeStatusChangedToInactive(props: Partial<Log>) {
  const { employee, employeeId } = props;
  const { t } = useTranslation();

  const employeeName = useMemo(
    () => employee ?? employeeId ?? "",
    [employee, employeeId]
  );

  return useMemo(
    () =>
      replaceByElement(
        t("log.employee_status_changed_inactive"),
        "{employee}",
        employeeName
      ),
    [employeeName, t]
  );
}
